import dynamic from "next/dynamic";
import SideBySideBoardViewsComponentTabsConfig from "./side-by-side-board-views-component-tabs-config";
import SideBySideBoardViewsComponentTabsAdvancedConfig from "./side-by-side-board-views-component-tabs-advanced-config";
const SideBySideBoardViewsComponentTabsComponent = dynamic(()=>import("./side-by-side-board-views-component-tabs-component"));
export default {
    SideBySideBoardViewsComponentTabsComponent,
    SideBySideBoardViewsComponentTabsConfig,
    SideBySideBoardViewsComponentTabsAdvancedConfig
};
